var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._g(_vm._b({staticClass:"theme-input",attrs:{"value":_vm.value,"items":_vm.items,"item-text":_vm.itemText,"item-value":_vm.itemValue,"loading":_vm.loading,"disabled":_vm.disabled,"clearable":_vm.clearable,"multiple":_vm.multiple,"chips":_vm.chips,"menu-props":{
    contentClass: 'theme-select-menu',
    transition: 'slide-y-transition',
    offsetY: true,
    maxHeight: 300,
  }},on:{"input":function($event){return _vm.mit('input', $event)}},scopedSlots:_vm._u([(_vm.$slots.selection)?{key:"selection",fn:function(ref){
  var item = ref.item;
  var index = ref.index;
return [_vm._t("selection",null,{"item":item,"index":index})]}}:null,(_vm.$slots.item)?{key:"item",fn:function(ref){
  var item = ref.item;
  var on = ref.on;
  var attrs = ref.attrs;
return [_vm._t("item",null,{"item":item,"on":on,"attrs":attrs})]}}:null,(_vm.$slots.append)?{key:"append",fn:function(){return [_vm._t("append")]},proxy:true}:null,(_vm.$slots.prepend)?{key:"prepend",fn:function(){return [_vm._t("prepend")]},proxy:true}:null],null,true)},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }